import React from "react";
import { SectionTitle } from "@/components/Section";
import { DISCLAIMER, CONTACT } from "@/lib/constants";

const SECTIONS = [
  { h: "1. Introduction", p: "UPSC With Arpita (\"we\", \"us\", \"our\") is committed to protecting the privacy of students and visitors who use this educational platform. This Privacy Policy explains how we collect, use, and safeguard your information." },
  { h: "2. Information We Collect", p: "When you create a free account, we collect your full name, email address, mobile number, target UPSC year, state, and how you heard about us. When you contact us, we store the details you submit through our contact form." },
  { h: "3. How We Use Your Information", p: "We use your information to provide access to Revision Kits, respond to your queries, send you relevant updates about new kits and courses, and improve our content. We do not sell your personal information to third parties." },
  { h: "4. Communication", p: "By registering, you consent to receiving educational updates via email, Telegram, or other channels you have opted into. You may opt out of promotional communication at any time." },
  { h: "5. Data Security", p: "We take reasonable technical and organisational measures to protect your data. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security." },
  { h: "6. Third-Party Services", p: "Payments for paid courses are processed by Razorpay under their own privacy and security policies. We do not store your payment card details on our servers." },
  { h: "7. Your Rights", p: "You may request access to, correction of, or deletion of your personal data by contacting us at " + CONTACT.email + "." },
  { h: "8. Changes to this Policy", p: "We may update this Privacy Policy from time to time. The latest version will always be available on this page with the updated date shown in the footer." },
];

export default function Privacy() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <SectionTitle sub="How we handle your information" testId="privacy-title">Privacy Policy</SectionTitle>
      <div className="gov-card p-6">
        <p className="text-sm text-gray-600">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
        <div className="mt-4 space-y-5">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h3 className="font-serif text-base font-bold text-[#0B2545]">{s.h}</h3>
              <p className="mt-1 text-sm leading-relaxed text-gray-700">{s.p}</p>
            </div>
          ))}
        </div>
        <p className="mt-6 rounded-sm border border-[#FDE68A] bg-[#FEF3C7] p-4 text-xs leading-relaxed text-[#92400E]">
          <strong>Disclaimer:</strong> {DISCLAIMER}
        </p>
      </div>
    </div>
  );
}
